<template>
  <p
    v-if="receipt.fulfillmentType === 'Delivery'"
    class="cf-subtitle cf-subtitle--2"
  >
    Delivery time {{ $momentCalendar(receipt.delivery.estimatedDeliveryTime, null, receipt.store.timeZone) }}
  </p>

  <p
    v-else-if="isPickupType"
    class="cf-subtitle cf-subtitle--1"
  >
    Pickup time {{ $momentCalendar(receipt.pickupDate, null, receipt.store.timeZone) }}
  </p>

  <p
    v-else-if="receipt.fulfillmentType === 'RoomService'"
    class="cf-subtitle cf-subtitle--1"
  >
    Delivery time {{ $momentCalendar(receipt.pickupDate, null, receipt.store.timeZone) }}
  </p>
</template>


<script>
  export default {
    name: 'ReceiptOrderFulfillmentTime',

    props: {
      receipt: {
        type: Object,
        required: true
      }
    },

    computed: {
      isPickupType() {
        return this.receipt.fulfillmentType === 'Takeout'
          || this.receipt.fulfillmentType === 'Curbside'
          || this.receipt.fulfillmentType === 'DriveThrough';
      }
    }
  };
</script>
